import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    list: {
        isLoading: false,
        data: null
    },
    types: {
        isLoading: false,
        data: null
    },
    purposes: {
        isLoading: false,
        data: null
    },
    flavors: {
        isLoading: false,
        data: null
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case CONSTANTS.ON_METERS_ARE_LOADING:
            return state.setIn(['list', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_METERS_LIST:
            return state.setIn(['list', 'data'], payload.data);

        case CONSTANTS.ON_METER_TYPES_ARE_LOADING:
            return state.setIn(['types', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_METER_TYPES_LIST:
            return state.setIn(['types', 'data'], payload.data);

        case CONSTANTS.ON_METER_PURPOSES_ARE_LOADING:
            return state.setIn(['purposes', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_METER_PURPOSES_LIST:
            return state.setIn(['purposes', 'data'], payload.data);

        case CONSTANTS.ON_METER_FLAVORS_ARE_LOADING:
            return state.setIn(['flavors', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_METER_FLAVORS_LIST:
            return state.setIn(['flavors', 'data'], payload.data);            

        default:
            return state;
    }
};

export default reducer;
